// src/config/api.config.js

export const ADMIN_WORKER_URL = 'https://dsi-worker-admin.kiemdedavid23.workers.dev';

// Récupération sécurisée du token d'authentification
export const getAdminAuthToken = () => {
  return localStorage.getItem('dsi_admin_token') || null;
};

// Sauvegarde / Suppression du token
export const setAdminAuthToken = (token) => {
  if (token) {
    localStorage.setItem('dsi_admin_token', token);
  } else {
    localStorage.removeItem('dsi_admin_token');
  }
};

// Suppression explicite du token uniquement
export const removeAdminAuthToken = () => {
  localStorage.removeItem('dsi_admin_token');
};

/**
 * Purge complète de la session Admin côté navigateur :
 * token, payload /admin/me, miroir utilisateur, clés legacy.
 * Utilisé par authService.logout() et par apiFetch sur 401.
 */
export const clearAdminLocalSession = () => {
  try {
    localStorage.removeItem('dsi_admin_token');
    localStorage.removeItem('dsi_admin_session');
    localStorage.removeItem('dsi_admin_user');
    localStorage.removeItem('admin_token');
  } catch {
    /* ignore */
  }
};
